import { render, staticRenderFns } from "./AreasCadastro.vue?vue&type=template&id=4e841dd0&scoped=true&"
import script from "./AreasCadastro.vue?vue&type=script&lang=js&"
export * from "./AreasCadastro.vue?vue&type=script&lang=js&"
import style0 from "./AreasCadastro.vue?vue&type=style&index=0&id=4e841dd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e841dd0",
  null
  
)

export default component.exports